import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import AddNewButton from 'components/ActionButtons/addNewButton';
import List from './list';
import AddDialog from './addDialog';
import ConfirmDialog from 'components/Dialogs/ConfirmDialog';
import FilterBox from './filter';
import * as EmployeeAction from 'store/actions/employee';
import * as InformationAction from 'store/actions/information';
import * as PositionInformation from 'store/actions/position';
import { t } from 'i18next';

function Employee() {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);
  const [showDelete, setShowDelete] = React.useState(false);

  const dispatch = useDispatch();

  const employees = useSelector((state) => state.information.employees);

  const headers = ['no', 'name', 'id', 'phonenumber', 'position', 'branch', 'created_at', 'created_by', ''];
  React.useEffect(() => {
    dispatch(EmployeeAction.getAll({}));
    dispatch(InformationAction.getBranch());
    dispatch(PositionInformation.getAll());
  }, [EmployeeAction.getAll, InformationAction.getBranch, PositionInformation.getAll, dispatch]);

  return (
    <>
      <List
        headers={headers}
        data={employees}
        onEdit={(data) => {
          setModalOpen(true);
          setEditData(data);
        }}
        onDelete={(data) => {
          setShowDelete(true);
          setEditData(data);
        }}
        filter={<FilterBox onSearch={(value) => dispatch(EmployeeAction.getAll(value))} />}
        buttons={
          <>
            <AddNewButton
              type='employee'
              onClick={() => {
                setModalOpen(true);
                setEditData(null);
              }}
            />
            <Button style={{ width: 100 }} size='sm' onClick={() => window.location.reload()}>
              <i className='fa fa-spinner mr-2' /> {t('refresh')}
            </Button>
          </>
        }
      />
      <AddDialog
        title={editData ? `${t('edit')} ${t('employee')}` : `${t('add')} ${t('employee')}`}
        editData={editData}
        modalOpen={modalOpen}
        onToggle={(open) => setModalOpen(open)}
        onSubmit={(values) => {
          setModalOpen(false);
          if (editData) dispatch(EmployeeAction.update({ ...values, _id: editData?._id }));
          else dispatch(EmployeeAction.save(values));
          setTimeout(() => dispatch(EmployeeAction.getAll({}, true)), 1000);
        }}
      />
      <ConfirmDialog
        modalOpen={showDelete}
        title={`${t('delete')} ${t('employee')}`}
        body={`${t('confirm_delete')} ${editData?.name}?`}
        onToggle={() => setShowDelete(false)}
        onConfirm={() => {
          setShowDelete(false);
          dispatch(EmployeeAction.deleteData(editData?._id));
          setTimeout(() => dispatch(EmployeeAction.getAll()), 1000);
        }}
      />
    </>
  );
}

export default Employee;
